import * as Factory from 'factory.ts'

import { type GlobalAPIResponse } from '@webapp/api/GlobalAPI'
import { CurrencyMock } from './currency.factory'
import { DepartmentMock } from './department.factory'
import { UserMock } from './user.factory'

export const GlobalMock = Factory.Sync.makeFactory<GlobalAPIResponse>({
  user_profile: UserMock.build(),
  department: DepartmentMock.build(),
  domain: 'test',
  company: null,
  feature_switches: null,
  site_name: '',
  application_status: null,
  active_sso_option: null,
  contenttypes: [],
  pix_host: '',
  base_currency: CurrencyMock.build(),
  url: {
    pix: '',
    static: '',
    media: '',
  },
  system_preferences: {
    'bill-received-only': null,
    'custom-labels': null,
    locale: null,
    rfo_lock_default: null,
    'default-disclaimer': null,
  },
  sdk_keys: null,
  filtered_navigation: [],
  permissions: [],
  analytics: null,
  role: null,
  headquarters_timezone: null,
  setup_progress: {
    accountcode_setup: false,
    approvalgroup_setup: false,
    approvalrouting_setup: false,
    basic_company_setup: false,
    budget_setup: false,
    completed_count: 0,
    completed_percentage: 0,
    database_initialized: 0,
    demo_data_cleared: false,
    department_setup: 0,
    show: false,
    user_setup: false,
    spending_card_bank_account_setup: false,
    is_financial_account_setup: false,
  },
  go_live: {
    show_splash: false,
    message: '',
  },
  env: 'development',
})
